(() => {
  if (window.__leatherProjectMetaPixel) return;
  window.__leatherProjectMetaPixel = true;

  const pixelId = '4533818060236806';
  let initialized = false;
  let pageViewSent = false;
  let loadingPrivacy = false;

  function updateConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const allowed = privacy.marketingAllowed() && privacy.saleOfDataAllowed();

    if (!allowed) {
      if (initialized) window.fbq('consent', 'revoke');
      return;
    }

    if (!initialized) {
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');

      window.fbq('set', 'autoConfig', false, pixelId);
      window.fbq('init', pixelId);
      initialized = true;
    }

    window.fbq('consent', 'grant');
    if (!pageViewSent) {
      window.fbq('trackSingle', pixelId, 'PageView');
      pageViewSent = true;
    }
  }

  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy) {
      updateConsent();
    } else if (window.Shopify?.loadFeatures && !loadingPrivacy) {
      loadingPrivacy = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        loadingPrivacy = false;
        if (!error) updateConsent();
      });
    }
  }

  document.addEventListener('visitorConsentCollected', updateConsent);
  window.addEventListener('load', loadPrivacy, { once: true });
  loadPrivacy();
})();
